import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { AppConfig } from "../../AppConfig";
import { LocalStorageManager } from "../../core/storage/LocalStorageManager";
import { UserRole } from "../user";
import { authActions } from "./actions";
import { AuthState } from "./types";
import { USER_ROLE } from "../../constants/app";

const initialState: AuthState = {
  isLoggedIn: null,
  loggedInUser: null,
};

export function AuthReducer(state = initialState, action: Action): AuthState {
  if (isType(action, authActions.setIsLoggedIn)) {
    return {
      ...state,
      isLoggedIn: action.payload,
    };
  }

  if (isType(action, authActions.getLoggedInUser.done)) {
    return {
      ...state,
      loggedInUser: action.payload.result,
    };
  }

  if (isType(action, authActions.verifyPhoneNumber.done)) {
    const loggedInUser = {
      id: action.payload.result.id,
      firstName: action.payload.result.first_name,
      lastName: action.payload.result.last_name,
      customer_name: action.payload.result.customer_name,
      role:
        action.payload.result.role === USER_ROLE.SYSTEM_ADMINISTRATOR
          ? UserRole.Admin
          : action.payload.result.role === USER_ROLE.USER
            ? UserRole.User
            : UserRole.GroupAdmin,
    };

    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["loggedInUser"],
      loggedInUser,
    );

    return {
      ...state,
      // isLoggedIn: true,
      loggedInUser,
    };
  }

  if (isType(action, authActions.verifyEmail.done)) {
    const loggedInUser = {
      id: action.payload.result.id,
      firstName: action.payload.result.first_name,
      lastName: action.payload.result.last_name,
      customer_name: action.payload.result.customer_name,
      role:
        action.payload.result.role === USER_ROLE.SYSTEM_ADMINISTRATOR
          ? UserRole.Admin
          : action.payload.result.role === USER_ROLE.USER
            ? UserRole.User
            : UserRole.GroupAdmin,
    };

    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["loggedInUser"],
      loggedInUser,
    );

    return {
      ...state,
      loggedInUser,
    };
  }

  if (isType(action, authActions.loginWithPasskey.done)) {
    const loggedInUser = {
      id: action.payload.result.id,
      firstName: action.payload.result.first_name,
      lastName: action.payload.result.last_name,
      customer_name: action.payload.result.customer_name,
      role:
        action.payload.result.role === USER_ROLE.SYSTEM_ADMINISTRATOR
          ? UserRole.Admin
          : action.payload.result.role === USER_ROLE.USER
            ? UserRole.User
            : UserRole.GroupAdmin,
    };

    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["loggedInUser"],
      loggedInUser,
    );

    return {
      ...state,
      loggedInUser,
    };
  }

  if (isType(action, authActions.tokenLogin.done)) {
    const loggedInUser = {
      id: action.payload.result.id.toString(),
      firstName: action.payload.result.first_name,
      lastName: action.payload.result.last_name,
      customer_name: action.payload.result.customer_name,
      role:
        action.payload.result.role === USER_ROLE.SYSTEM_ADMINISTRATOR
          ? UserRole.Admin
          : action.payload.result.role === USER_ROLE.USER
            ? UserRole.User
            : UserRole.GroupAdmin,
    };

    LocalStorageManager.Instance.saveObject(
      AppConfig.Instance.LocalStorageKey["loggedInUser"],
      loggedInUser,
    );

    return {
      ...state,
      loggedInUser,
    };
  }

  if (isType(action, authActions.logout.done)) {
    return {
      ...state,
      isLoggedIn: false,
      loggedInUser: null,
    };
  }

  if (isType(action, authActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
